import { Navigate, Outlet } from "@tanstack/react-router";

import { useOrganization } from "@/context/organization-provider";
import { useUserStore } from "@/stores/user-store";

export const Route = createFileRoute({
  component: RouteComponent,
});

function RouteComponent() {
  const { orgId } = Route.useParams();
  const memberships = useUserStore((state) => state.memberships);
  const [activeMembership, setActiveMembership] = useOrganization();

  if (orgId === activeMembership.id) {
    return <Outlet />;
  }

  const organization = memberships.find((x) => x.id === orgId);
  if (organization) {
    setActiveMembership(organization, false);
    return <Outlet />;
  } else {
    return (
      <Navigate
        to="/$orgId/dashboard"
        params={{ orgId: activeMembership.id }}
      />
    );
  }
}
